export default "__VITE_ASSET__5d179757__"